import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import { RoomTypePickerComponent } from "./RoomTypePickerComponent";

interface RoomTypePickerProps {
  liveStreamConfig: Record<string, string>;
  name: string;
  rules?: Partial<RegisterOptions>;
  shouldDisableEventOption: boolean;
}

export const RoomTypePicker = ({
  name,
  rules,
  liveStreamConfig,
  shouldDisableEventOption,
  ...passThroughProps
}: RoomTypePickerProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <RoomTypePickerComponent
          {...passThroughProps}
          onChange={onChange}
          value={value}
          liveStreamConfig={liveStreamConfig}
          shouldDisableEventOption={shouldDisableEventOption}
        />
      )}
    />
  );
};
